module.exports = __webpack_public_path__ + "img/ugyot_no.3a48864a.png";